module.exports = __webpack_public_path__ + "static/img/Jerman.75e0431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Jerman.png
// module id = 6PGW
// module chunks = 1